import { t } from '@lingui/core/macro'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { isHTTPError } from 'ky'

import { antdStaticApp } from '@/tshared/web/components/AntdStaticApp.tsx'

type ApiErrorData = {
  showMessage?: boolean
  message?: unknown
}

function getApiErrorData(data: unknown): ApiErrorData | null {
  return data && typeof data === 'object' ? (data as ApiErrorData) : null
}

function getApiErrorMessage(data: ApiErrorData): string {
  return typeof data.message === 'string' && data.message.length > 0
    ? data.message
    : t`An error occurred`
}

function handleApiError(error: unknown) {
  if (!isHTTPError(error)) return

  if (error.response.status === 403) {
    antdStaticApp.message.error(t`You are not authorized to access this resource`)
    return
  }

  const data = getApiErrorData(error.data)
  if (data?.showMessage) {
    antdStaticApp.message.error(getApiErrorMessage(data))
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: handleApiError,
  }),
  mutationCache: new MutationCache({
    onError: handleApiError,
  }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    },
  },
})

export default queryClient
